// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ComposerController from "./composer_controller";
import HelloController from "./hello_controller";
import ParallaxController from "./parallax_controller";
import RevealController from "./reveal_controller";

application.register("composer", ComposerController);
application.register("hello", HelloController);
application.register("parallax", ParallaxController);
application.register("reveal", RevealController);
